module.exports = __webpack_public_path__ + "static/media/phone2x.adac6a07.png";